export const blockIconsHardwareDeveloperBoardNew = (
	<span className='material-symbols-outlined'>developer_board</span>
);
